import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE = {
  'loading': false,
  'list': [],
  'listSet': [],
  'filteredList': [],
  'pageSize': 20,
  'pageNumber': 0,
  'urlFile': '',
  'loadButton': false,
  'vehInf': [],
};

const getPage = (list, pageNumber, pageSize) => {
  if (list.length <= pageSize) {
    return [...list];
  }
  if (list.length > (pageSize * (pageNumber + 1))) {
    return [...list].slice(
      (pageSize * pageNumber),
      (pageSize * (pageNumber + 1))
    );
  }
  return [...list].slice(pageNumber * pageSize);
};

export const vehAudi = (state, action) => {
  return createReducer(INITIAL_STATE, {
    [ActionTypes.SUBMIT_EXECUTE_VEH_AUDI_SUCCESS]: (state, action) => ({
      ...state,
      'loading': false,
      'loadButton': true,
      'values': {...state.values},
    }),
    [ActionTypes.SUBMIT_EXECUTE_VEH_AUDI_REQUEST]: (state, action) => ({
      ...state,
      'loading': true,
      'loadButton': true,
    }),
    [ActionTypes.SUBMIT_EXECUTE_VEH_AUDI_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
    }),
    [ActionTypes.FETCHING_VEH_AUDI_REPORT]: (state, action) => ({
      ...state,
      'loading': true,
      'loadButton': true,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_REPORT]: (state, action) => ({
      ...state,
      'list': action.response.data,
      'filteredList': [...getPage(action.response.data, 0, state.pageSize)],
      'loading': false,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_REPORT_FAILED]: (state, action) => ({
      ...state,
      'list': [],
      'filteredList': [],
      'pageSize': 20,
      'pageNumber': 0,
      'loading': false,
    }),
    [ActionTypes.FETCHING_VEH_AUDI_SET_REPORT]: (state, action) => ({
      ...state,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_SET_REPORT]: (state, action) => ({
      ...state,
      'listSet': action.response.data,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_SET_REPORT_FAILED]: (state, action) => ({
      ...state,
      'listSet': [],
    }),
    [ActionTypes.DELETE_VEH_AUDI_REPORT]: () => ({
      ...state,
      'list': [],
      'listSet': [],
      'filteredList': [],
      'pageSize': 20,
      'pageNumber': 0,
      'loading': false,
      'urlFile': '',
      'vehInf': [],
    }),
    [ActionTypes.DELETE_URL_AUDI]: () => ({
      ...state,
      'urlFile': '',
    }),
    [ActionTypes.CHANGE_VEH_AUDI_REPORT_LIST_PAGE]: (state, action) => ({
      ...state,
      'pageNumber': action.payload,
      'filteredList': [...getPage(state.list, action.payload, state.pageSize)],
      'urlFile': '',
    }),
    [ActionTypes.CHANGE_VEH_AUDI_REPORT_LIST_PAGE_SIZE]: (state, action) => ({
      ...state,
      'pageSize': action.payload,
      'pageNumber': 0,
      'filteredList': [...getPage(state.list, 0, action.payload)],
      'urlFile': '',
    }),

    [ActionTypes.DOWNLOADING_VEH_AUDI_REPORT_LIST_FILE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_VEH_AUDI_REPORT_LIST_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': '',
    }),
    [ActionTypes.DOWNLOADING_VEH_AUDI_SET_REPORT_FILE]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.DOWNLOADED_VEH_AUDI_SET_REPORT_FILE]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': action.response.data,
    }),
    [ActionTypes.DOWNLOADED_VEH_AUDI_SET_REPORT_FILE_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'urlFile': '',
    }),
    [ActionTypes.FETCHING_VEH_AUDI_INF]: (state, action) => ({
      ...state,
      'loadButton': true,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_INF]: (state, action) => ({
      ...state,
      'vehInf': action.response.data,
      'loadButton': false,
    }),
    [ActionTypes.FETCHED_VEH_AUDI_INF_FAILED]: (state, action) => ({
      ...state,
      'loadButton': false,
      'vehInf': [],
    }),
  })(state, action);
};
